import styled from '@emotion/styled';

import { ButtonBase } from 'components/buttons/ButtonBase';

export const ButtonPrimary = styled(ButtonBase)`
  position: relative;
  line-height: 3rem;
  border-radius: 0;
  min-width: 0;
  margin: 0 4px; /* account for left and right borders */
  background: ${({ theme, submit }) =>
    submit ? theme.colors.secondary : theme.colors.action};

  &:hover {
    background: ${({ theme, submit }) =>
      submit ? '#ff8700' : theme.colors.actionStrong};
    opacity: 1;
  }

  &:before,
  &:after {
    position: absolute;
    content: '';
    width: 8px;
    height: 100%;
    border-radius: 50%;
    background: inherit;
  }

  &:before {
    left: -4px;
  }

  &:after {
    right: -4px;
  }
`;
